import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const SpecialOffersPage = () => {
  const offers = [
    {
      title: 'Spring Heating Service',
      discount: '€50 OFF',
      description: 'Get your heating system ready for next winter with our comprehensive service package.',
      validUntil: 'Valid until 31st March 2025',
      features: [
        'Full system inspection',
        'Boiler servicing',
        'Radiator bleeding',
        'Thermostat check',
        'Safety certification',
      ],
      originalPrice: '€250',
      offerPrice: '€200',
      image: 'https://static.readdy.ai/image/2b8febc409be403949093d91f25c447f/9821745b69ec015dc8abeaaa4b14af3f.jpeg',
    },
    {
      title: 'Bathroom Refresh Package',
      discount: 'There is a 20% discount on the installation of every 3 toilets.',
      description: 'Transform your bathroom with our special package deal including fixtures and installation.',
      validUntil: 'Valid until 30th April 2025',
      features: [
        'New toilet installation',
        'Modern washbasin',
        'Chrome mixer taps',
        'Professional fitting',
        'Waste disposal included',
      ],
      originalPrice: '€2,000',
      offerPrice: '€1,500',
      image: 'https://public.readdy.ai/ai/img_res/94e413768a2f5e9cb283fbe54ad3044a.jpg',
      featured: true,
    },
    {
      title: 'Heat Pump Installation',
      discount: '€50 OFF',
      description: 'Switch to eco-friendly heating with our special heat pump installation offer.',
      validUntil: 'Valid until 31st May 2025',
      features: [
        'Air-to-water heat pump',
        'Professional installation',
        'System commissioning',
        'User training included',
        'Grant application support',
      ],
      originalPrice: '€12,000',
      offerPrice: '€11,000',
      image: 'https://readdy.ai/api/search-image?query=modern%20heat%20pump%20outdoor%20unit%20installation%20energy%20efficient%20system%20professional%20mounting%20eco-friendly%20heating%20solution%20clean%20setup%20light%20background&width=800&height=600&seq=offer-003&orientation=landscape',
    },
    {
      title: 'Emergency Plumbing Bundle',
      discount: '15% OFF',
      description: 'Pre-pay for emergency callouts and save on urgent plumbing repairs.',
      validUntil: 'Valid for 12 months',
      features: [
        '3 emergency callouts',
        'Priority response',
        '24/7 availability',
        'Parts at cost price',
        'No hidden fees',
      ],
      originalPrice: '€450',
      offerPrice: '€382',
      image: 'https://readdy.ai/api/search-image?query=emergency%20plumbing%20repair%20work%20professional%20plumber%20fixing%20pipes%20urgent%20service%20tools%20and%20equipment%20clean%20professional%20work%20light%20neutral%20setting&width=800&height=600&seq=offer-004&orientation=landscape',
    },
    {
      title: 'Radiator Upgrade Deal',
      discount: 'Every 8th radiator installation is free.',
      description: 'Upgrade multiple radiators and get one free with professional installation included.',
      validUntil: 'Valid until 30th June 2025',
      features: [
        'Modern designer radiators',
        'Professional installation',
        'Old radiator removal',
        'System balancing',
        'Quality guarantee',
      ],
      originalPrice: '€2,400',
      offerPrice: '€1,800',
      image: 'https://readdy.ai/api/search-image?query=modern%20designer%20radiators%20installation%20contemporary%20heating%20units%20sleek%20design%20professional%20mounting%20clean%20wall%20setup%20light%20neutral%20interior&width=800&height=600&seq=offer-005&orientation=landscape',
    },
    {
      title: 'Underfloor Heating Special',
      discount: 'For installations over 100 square meters, 10% OFF',
      description: 'Install underfloor heating in your home with our limited-time special offer.',
      validUntil: 'Valid until 31st July 2025',
      features: [
        'Electric or water system',
        'Up to 20m² coverage',
        'Smart thermostat included',
        'Professional installation',
        '10-year warranty',
      ],
      originalPrice: '€4,500',
      offerPrice: '€3,700',
      image: 'https://static.readdy.ai/image/2b8febc409be403949093d91f25c447f/15d9addd3d9e538202701c3530865f7d.jpeg',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-20">
        {/* Hero Section */}
        <section className="bg-gradient-to-r from-accent to-accent-dark text-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl">
              <div className="inline-block bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
                <span className="text-sm font-semibold whitespace-nowrap">🎉 LIMITED TIME OFFERS</span>
              </div>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6">
                Special Offers
              </h1>
              <p className="text-lg sm:text-xl text-white/90 leading-relaxed">
                Take advantage of our exclusive deals on plumbing and heating services. Quality work at unbeatable prices for a limited time only!
              </p>
            </div>
          </div>
        </section>

        {/* Why Choose Us Section */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl sm:text-4xl font-bold text-primary mb-4">
                Why Choose Smart Heatplumb?
              </h2>
              <p className="text-gray-600 text-lg max-w-2xl mx-auto">
                Whether you need a plumber, routine maintenance, or a full heating installation, our qualified team is here to deliver a trustworthy, stress-free service.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                <div className="w-14 h-14 flex items-center justify-center bg-accent/10 rounded-lg mb-4">
                  <i className="ri-money-euro-circle-line text-accent text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-primary mb-3">No Call-Out Fees</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  You don't pay for us just to show up. We believe in fair pricing from the start.
                </p>
              </div>

              <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                <div className="w-14 h-14 flex items-center justify-center bg-accent/10 rounded-lg mb-4">
                  <i className="ri-file-list-3-line text-accent text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-primary mb-3">Written Quotes Upfront</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Complete pricing details before work starts, so there are no surprises.
                </p>
              </div>

              <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                <div className="w-14 h-14 flex items-center justify-center bg-accent/10 rounded-lg mb-4">
                  <i className="ri-checkbox-circle-line text-accent text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-primary mb-3">Only Pay for Work Done</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  You're charged solely for the labour and materials agreed. No hidden costs.
                </p>
              </div>

              <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                <div className="w-14 h-14 flex items-center justify-center bg-accent/10 rounded-lg mb-4">
                  <i className="ri-award-line text-accent text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-primary mb-3">High-Quality Workmanship</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  All plumbing and heating work carried out to the highest professional standards.
                </p>
              </div>

              <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                <div className="w-14 h-14 flex items-center justify-center bg-accent/10 rounded-lg mb-4">
                  <i className="ri-customer-service-2-line text-accent text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-primary mb-3">Friendly, Reliable Service</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Professional support before, during, and after every job. We're here for you.
                </p>
              </div>

              <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                <div className="w-14 h-14 flex items-center justify-center bg-accent/10 rounded-lg mb-4">
                  <i className="ri-team-line text-accent text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-primary mb-3">Volume Work Discounts</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Our company offers individual rates for large volumes of work. Contact us for details.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Offers Grid */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl sm:text-4xl font-bold text-primary mb-4">
                Current Special Offers
              </h2>
              <p className="text-gray-600 text-lg">
                Limited-time deals on our most popular services
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {offers.map((offer, index) => (
                <div
                  key={index}
                  className={`relative bg-white rounded-2xl overflow-hidden transition-all duration-300 ${
                    offer.featured
                      ? 'border-2 border-accent shadow-2xl'
                      : 'border border-gray-200 shadow-lg hover:shadow-xl'
                  }`}
                >
                  {/* Discount Badge */}
                  <div className="absolute top-4 right-4 z-10">
                    <div className="bg-accent text-white px-4 py-2 rounded-full font-bold text-sm shadow-lg whitespace-nowrap">
                      {offer.discount}
                    </div>
                  </div>

                  {offer.featured && (
                    <div className="absolute top-4 left-4 z-10">
                      <div className="bg-primary text-white px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap">
                        BEST VALUE
                      </div>
                    </div>
                  )}

                  {/* Image */}
                  <div className="aspect-[4/3] w-full h-full overflow-hidden">
                    <img
                      src={offer.image}
                      alt={offer.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>

                  {/* Content */}
                  <div className="p-6">
                    <h3 className="text-2xl font-bold text-primary mb-2">
                      {offer.title}
                    </h3>
                    <p className="text-gray-600 text-sm mb-4">{offer.description}</p>

                    {/* Price */}
                    <div className="mb-4">
                      <div className="flex items-baseline space-x-2">
                        <span className="text-3xl font-bold text-accent">
                          {offer.offerPrice}
                        </span>
                        <span className="text-gray-400 line-through text-lg">
                          {offer.originalPrice}
                        </span>
                      </div>
                    </div>

                    {/* Features */}
                    <ul className="space-y-2 mb-6">
                      {offer.features.map((feature, idx) => (
                        <li key={idx} className="flex items-start text-sm">
                          <i className="ri-check-line text-accent text-lg mr-2 flex-shrink-0"></i>
                          <span className="text-gray-700">{feature}</span>
                        </li>
                      ))}
                    </ul>

                    {/* Valid Until */}
                    <div className="flex items-center text-xs text-gray-500 mb-4">
                      <i className="ri-time-line mr-2"></i>
                      <span>{offer.validUntil}</span>
                    </div>

                    {/* CTA Button */}
                    <a
                      href="/#contact"
                      className={`block w-full text-center py-3 rounded-lg font-semibold transition-colors whitespace-nowrap ${
                        offer.featured
                          ? 'bg-accent hover:bg-accent-dark text-white'
                          : 'bg-primary hover:bg-primary-dark text-white'
                      }`}
                    >
                      Claim This Offer
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Charge Rates Section */}
        <section className="py-20 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl font-bold text-primary mb-6 text-center">
              Charge Rates
            </h2>
            <div className="bg-white rounded-xl p-8 border border-gray-200 mb-8">
              <div className="flex items-start space-x-4 mb-6">
                <div className="w-12 h-12 flex items-center justify-center bg-accent/10 rounded-lg flex-shrink-0">
                  <i className="ri-time-line text-accent text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-primary mb-2">Minimum Labour Charge</h3>
                  <p className="text-gray-700 mb-2">
                    <strong className="text-accent text-xl">€95 + VAT</strong> for the first hour
                  </p>
                  <p className="text-sm text-gray-600">
                    This includes investigation and diagnostic charges on-site
                  </p>
                </div>
              </div>
              <div className="bg-gray-50 rounded-lg p-4 border-l-4 border-accent">
                <p className="text-sm text-gray-700">
                  <i className="ri-information-line text-accent mr-2"></i>
                  Any investigation and/or diagnostic on-site is classified as a labour charge.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Terms Section */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl font-bold text-primary mb-6 text-center">
              Terms &amp; Conditions
            </h2>
            <div className="bg-white rounded-xl p-8 border border-gray-200">
              <ul className="space-y-3 text-sm text-gray-600">
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-line text-accent mr-3 mt-0.5 flex-shrink-0"></i>
                  <span>All offers are subject to availability and valid for new bookings only</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-line text-accent mr-3 mt-0.5 flex-shrink-0"></i>
                  <span>Offers cannot be combined with other promotions or discounts</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-line text-accent mr-3 mt-0.5 flex-shrink-0"></i>
                  <span>Prices are inclusive of VAT and standard installation </span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-line text-accent mr-3 mt-0.5 flex-shrink-0"></i>
                  <span>Additional charges may apply for complex installations or remote locations</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-line text-accent mr-3 mt-0.5 flex-shrink-0"></i>
                  <span>Smart Heatplumb Limited reserves the right to modify or withdraw offers at any time</span>
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl sm:text-4xl font-bold text-primary mb-6">
              Don't Miss Out on These Deals!
            </h2>
            <p className="text-gray-600 text-lg mb-8">
              Leave your requests, we will be happy to answer you. Contact us today to claim your special offer before it expires.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/#contact"
                className="inline-flex items-center justify-center space-x-2 bg-accent hover:bg-accent-dark text-white px-8 py-4 rounded-lg font-medium transition-colors whitespace-nowrap"
              >
                <span>Claim Your Offer</span>
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="tel:+353873719751"
                className="inline-flex items-center justify-center space-x-2 bg-white border-2 border-primary text-primary hover:bg-primary hover:text-white px-8 py-4 rounded-lg font-medium transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line"></i>
                <span>Call Now</span>
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default SpecialOffersPage;